import { ITutorialJourneyProfileDto } from "@growth-machine-llc/stridist-api-client";
import { Avatar, Chip, Tooltip, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React from "react";

const useStyles = makeStyles((theme) => ({
  chip: {
    marginLeft: theme.spacing(1),
    color: theme.palette.common.white,
  },
  current: {
    backgroundColor: theme.palette.success.light,
  },
  different: {
    backgroundColor: theme.palette.grey[400],
    color: theme.palette.text.primary,
  },
}));

interface AppliedProfileChipProps {
  appliedProfile: ITutorialJourneyProfileDto;
  isCurrent?: boolean;
}

export function AppliedProfileChip({
  appliedProfile,
  isCurrent = false,
}: AppliedProfileChipProps) {
  const s = useStyles();

  return (
    <Tooltip
      title={
        isCurrent ? (
          <Typography variant="caption">
            This item already has the <strong>current</strong> profile assigned:{" "}
            <strong>{appliedProfile.name}</strong>
          </Typography>
        ) : (
          <Typography variant="caption">
            This item already has a <strong>different</strong> profile assigned:{" "}
            <strong>{appliedProfile.name}</strong>
          </Typography>
        )
      }
      arrow
    >
      <Chip
        avatar={<Avatar src={appliedProfile.avatar || ""} />}
        label={appliedProfile.name}
        className={`${s.chip} ${isCurrent ? s.current : s.different}`}
        size="small"
      />
    </Tooltip>
  );
}
